'use client';

import type { ComponentProps } from 'react';
import { Dialog } from 'radix-ui';
import { Button } from '@/components/ui/button';
import { DialogSurface } from '@/components/dialog-surface';
import { useHydrated } from '@/lib/use-hydrated';
import { WAITLIST_LABEL } from '../waitlist';
import { WaitlistForm } from './waitlist-form';

export function WaitlistButton({
  variant = 'default',
  className,
}: Pick<ComponentProps<typeof Button>, 'variant' | 'className'>) {
  const hydrated = useHydrated();

  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        <Button variant={variant} className={className} disabled={!hydrated}>
          {WAITLIST_LABEL}
        </Button>
      </Dialog.Trigger>
      <DialogSurface title="Join the Wolven waitlist">
        <Dialog.Description className="text-sm text-muted-foreground">
          Leave your email and we’ll be in touch.
        </Dialog.Description>
        <WaitlistForm autoFocus />
      </DialogSurface>
    </Dialog.Root>
  );
}
